module.exports = __webpack_public_path__ + "img/cb.d4faf220.png";